import React from 'react';
import './MailTag.scss';
const MailTag = props => {
    const { more, color, closeable = false, limit = false, onClose, className, style = {}, } = props;
    return (React.createElement("div", { className: `com-mail-tag ${className} ${more ? 'com-mail-tag-more' : ''} `, style: Object.assign(Object.assign({}, style), { backgroundColor: color }), "data-test-id": "mail-tag-item" },
        React.createElement("span", { className: `content ${limit ? 'com-mail-tag-limit' : ''} ` }, props.children),
        closeable ? (React.createElement("div", { className: "tag-extra", onClick: () => {
                onClose && onClose();
            }, style: { backgroundColor: color }, "data-test-id": "mail-tag-item-close" },
            React.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M2.25 7.75L5 5M5 5L2.25 2.25M5 5L7.75 7.75M5 5L7.75 2.25", stroke: "#6F7485", strokeLinejoin: "round" })))) : ('')));
};
export default MailTag;
